'use client';

import styles from './ColorDot.module.scss';

import type { CSSProperties } from 'react';

export type ColorDotSize = 'sm' | 'md' | 'lg';

type ColorDotProps = {
  color: string;
  size?: ColorDotSize;
  glow?: boolean;
  className?: string;
  ariaLabel?: string;
};

export function ColorDot({
  color,
  size = 'md',
  glow = true,
  className,
  ariaLabel,
}: ColorDotProps) {
  const classNames = [
    styles.colorDot,
    styles[`colorDot--${size}`],
    glow ? styles['colorDot--glow'] : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      className={classNames}
      role={ariaLabel ? 'img' : undefined}
      style={{ '--color-dot-color': color } as CSSProperties}
    />
  );
}
